import { createApi } from "@reduxjs/toolkit/query/react";
import { RESTAURANT_REQUEST } from "../../configs";
import { RestaurantRequest } from "../../types";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const restaurantRequestApi = createApi({
  reducerPath: RESTAURANT_REQUEST.reducerPath,
  baseQuery: createBaseQuery(RESTAURANT_REQUEST.baseUrl),
  tagTypes: RESTAURANT_REQUEST.tagTypes,
  endpoints(builder) {
    return {
      createRestaurantRequest: builder.mutation<
        RestaurantRequest,
        Omit<RestaurantRequest, "_id">
      >({
        query: (body) => ({
          url: "/",
          method: "POST",
          body,
        }),
        invalidatesTags: [{ type: RESTAURANT_REQUEST.tagTypes[0], id: "LIST" }],
      }),
    };
  },
});

// Export hooks
export const { useCreateRestaurantRequestMutation } = restaurantRequestApi;

export { restaurantRequestApi };
